<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">化学品入库记录</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="化学品名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="入库开始日期">
          <el-date-picker v-model="formInline.start_date" type="date" value-format="yyyy-MM-dd" clearable
            placeholder="选择开始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="入库结束日期">
          <el-date-picker v-model="formInline.end_date" type="date" value-format="yyyy-MM-dd" clearable
            placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商">
          <el-input v-model="formInline.supplier" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增入库记录</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="name" label="化学品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="cas_number" label="CAS号" width="120">
        </custom-table-column>
        <custom-table-column prop="" label="所属组织结构" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="total_quantity" label="入库数量" width="120">
        </custom-table-column>
        <custom-table-column prop="unit" label="单位" width="80">
        </custom-table-column>
        <custom-table-column prop="category" label="化学品分类" width="120">
        </custom-table-column>
        <custom-table-column prop="fx_level" label="风险等级" width="100">
        </custom-table-column>
        <custom-table-column prop="total_amount" label="总金额/元" width="100">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="inbound_time" label="入库时间" width="160">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">查看详情</el-button>
            <el-button @click="detailMethod(scope.row, 'edit')" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="type == 'view'" label-width="120px"
        :class="`demo-ruleForm ${type == 'view' ? 'view-form' : ''}`">
        <el-form-item label="化学品名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" clearable style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="CAS号" prop="cas_number">
          <el-input v-model="ruleForm.cas_number" placeholder="请输入" clearable style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属组织结构" prop="structure_1">
          <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
          </OrganDialog>
          <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
            @clear="handeleClear" @blur="handleBlurOrgan" clearable></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-select v-model="ruleForm.unit" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.chemicalUnit" :key="index" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="单价" prop="price">
          <el-input v-model="ruleForm.price" clearable placeholder="请输入" style="width:198px;"></el-input> 元
        </el-form-item> -->
        <el-form-item label="化学品分类" prop="category">
          <el-select v-model="ruleForm.category" clearable placeholder="请选择" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.chemicalCates" :key="index" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存放地点" prop="location">
          <el-input v-model="ruleForm.location" clearable placeholder="请输入" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="厂商" prop="manufacturer">
          <el-input v-model="ruleForm.manufacturer" clearable placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="注意事项" prop="notes">
          <el-input type="textarea" v-model="ruleForm.notes" placeholder="请输入" style="width:552px;" :rows="4">
          </el-input>
        </el-form-item>
        <el-form-item label="标识" prop="label" style="width:100%">
          <Uploadd ref="uploadd" fileFieldNameIn="label" btnTitle="点击上传图片" @setFileList="setFileListMultiple"
            uploadType="image" :limitt="1" @delFile="delUpFile"></Uploadd>
        </el-form-item>
        <!-- 物品风险评估 -->
        <div class="add_win ">
          <p class="add_win_title">AI风险评估 <span style="float:right;"><AiRiskAssessment :formData="ruleForm" apiUrl="api/v2/BdBce/runs?obj_type=chemical" nameField="name"
                :disabled="type == 'view'" /></span>
            </p>
          <div class="add_win_body el-form">
            <el-form-item label="风险等级" prop="fx_level">
              <el-select v-model="ruleForm.fx_level" placeholder="请选择风险等级" style="width:216px;" clearable>
                <el-option v-for="item in $store.state.dangerLevells" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="风险类型" prop="fx_type">
              <el-select v-model="ruleForm.fx_type" multiple placeholder="请选择风险类型" style="width:512px;" clearable>
                <el-option v-for="(item, index) in $store.state.dangerTypes" :key="index" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="存储要求" prop="fx_store">
              <el-input type="textarea" v-model="ruleForm.fx_store" placeholder="请输入存储要求" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="个人防护要求" prop="fx_protection">
              <el-input type="textarea" v-model="ruleForm.fx_protection" placeholder="请输入个人防护要求" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
            <el-form-item label="应急处理措施" prop="fx_measure">
              <el-input type="textarea" v-model="ruleForm.fx_measure" placeholder="请输入应急处理措施" style="width:512px;"
                :rows="3"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="add_win ">
          <p class="add_win_title">入库化学品清单</p>
          <div v-for="(item, index) in ruleForm.items" :key="index" class="add_win_body el-form">
            <el-form-item label="化学品编号" :prop="`items[${index}].item_code`">
              <el-input v-model="item.item_code" placeholder="请输入" style="width:196px;"></el-input>
            </el-form-item>
            <el-form-item label="化学品容量" :prop="`items[${index}].quantity`">
              <el-input v-model="item.quantity" placeholder="请输入" style="width:196px;"></el-input>
            </el-form-item>
            <el-form-item label="单价" :prop="`items[${index}].price`">
              <el-input v-model="item.price" placeholder="请输入" style="width:196px;"></el-input>
            </el-form-item>
            <div class="add_win_del">
              <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
            </div>
          </div>
          <div class="add_win_add">
            <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;" v-if="type != 'view'">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';
import AiRiskAssessment from '@/components/AiRiskAssessment.vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter, mixinUpload],
  components: {
    AiRiskAssessment,
  },
  data() {
    return {
      formInline: {
        name: '',
        cas_number: '',
        category: '',
        structure_1: '',
        structure_2: '',
        term: '',
        start_date: "",
        end_date: "",
      },
      props: {
        value: 'code',
        label: 'name',
        children: 'subcategories',
        emitPath: false
      },
      size: 'small',
      detailDialogVisible: false,
      levell: [1],
      selectName: '',
      organLabel: '',
      ruleForm: {
        "name": "",
        "cas_number": "",
        "category": "",
        "label": "",
        "unit": "",
        // "price": '',
        "location": "",
        "manufacturer": "",
        "structure_1": "",
        "structure_2": "",
        "term": "",
        "notes": "",
        "items": [{ "item_code": "", "quantity": '', "price": '' }],
        "fx_level": '',
        "fx_type": [],
        "fx_store": '',
        "fx_protection": '',
        "fx_measure": '',
      },
      rowObj: {},
      plist: [],
      classRooms: [],
      rules: {
      },
      rulesRoot: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        // cas_number: [{ required: true, message: '请输入', trigger: 'blur' }],
        structure_1: [{ required: true, message: '请选择' }],
        unit: [{ required: true, message: '请选择', trigger: 'change' }],
        // price: [
        //   { required: true, message: '请输入', trigger: 'blur' },
        //   { validator: this.checkfloat, trigger: 'blur' },
        // ],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        category: [{ required: true, message: '请选择', trigger: 'change' }],
        location: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/化学品入库导入模版.xlsx',
      btnTitle: '导入入库数据',
      listArr: [],
      subcategories: []
    };
  }, created() {
    this.action = `${this.baseUrlt}api/chemical/inbound/import-template`;
    this.$store.dispatch('getTermms');

  },
  computed: {
    total_price() {
      // this.total_price = this.item_code*this.price
      return (this.ruleForm.item_code * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() {
    this.rules = {
      ...this.rulesRoot,
      ...this.generateArrRules()
    };
  },
  methods: {

    generateArrRules() {
      const arrRules = {};
      this.ruleForm.items.forEach((item, index) => {
        arrRules[`items[${index}].item_code`] = [
          { required: true, message: `请输入`, trigger: 'blur' }
        ];
        arrRules[`items[${index}].quantity`] = [
          { required: true, message: `请输入`, trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ];
        arrRules[`items[${index}].price`] = [
          // { required: true, message: `请输入`, trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ];
      });
      return arrRules;
    },
    handleBlurOrgan() {
      console.log(this.ruleForm.structure_1)
    },
    handleItemDelete(item, index) {
      this.ruleForm.items.splice(index, 1);
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.$store.commit('setTrainRooms', [{ id: '0', training_name: '无' }]);
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleCascaderChage(val) {
      this.ruleForm.category_desc = this.$until.getLabelName(this.subcategories, 'code', 'name', val);
    },
    async detailMethod(row, type = "view") {
      let res = await this.$api.instance.interfaceServer(`api/chemical/inbound/detail/${row.id}`, 'get');
      if (res.code == 0 && res.data) {
        let params = res.data.inbound
        params.items = res.data.items.map(item => {
          return {
            quantity: item.quantity,
            item_code: item.item_code,
            price: item.price,
          }
        })
        // 风险类型回显：后端存为逗号分隔字符串，前端多选需要数组
        params.fx_type = row.fx_type || '';
        params.fx_level = row.fx_level || '';
        params.fx_store = row.fx_store || '';
        params.fx_protection = row.fx_protection || '';
        params.fx_measure = row.fx_measure || '';
        
        if (params.fx_type && typeof params.fx_type === 'string') {
          params.fx_type = params.fx_type.split(/[,，]/).map(s => s.trim()).filter(Boolean);
        }
        if (type == "edit") {
          this.handleEditNew(params)

        } else {
          this.handleDetailNew(params)
        }
        this.handleEditCallBackSetStruc({ row: params })
        this.handleEditCallBackSetFile({ fileField: "label", row: params })
        this.setRules();

      }
    },
    handleInput(item) {
      item.zj = item.dj * item.sl;
      // return  item.zj
    },
    setRules() {
      this.rules = {
        ...this.rulesRoot,
        ...this.generateArrRules()
      };
    },
    handleItemAdd() {
      if (this.ruleForm.items.length) {
        const item = this.$until.easyDeepCopy(this.ruleForm.items[this.ruleForm.items.length - 1]);
        this.ruleForm.items.push(item);
      } else {
        this.ruleForm.items.push({ item_code: '', quantity: '', price: '' });
      }
      this.setRules();
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/chemical/inbound/delete/${this.delid}`, 'DELETE');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // 风险类型数组转为逗号分隔字符串提交
      if (params.fx_type && Array.isArray(params.fx_type)) {
        params.fx_type = params.fx_type.join(',');
      }
      let res = await this.$api.instance.interfaceServer('api/chemical/inbound/inbound', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      // 风险类型数组转为逗号分隔字符串提交
      if (params.fx_type && Array.isArray(params.fx_type)) {
        params.fx_type = params.fx_type.join(',');
      }
      let res = await this.$api.instance.interfaceServer(`api/chemical/inbound/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, major: "structure_2" });
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/inbound/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createMethod();
          } else if (this.type == 'edit') {
            this.updateMethod();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
